<template>
    <div class="row basemap-gallery">
        <div class="col-12">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <MaterialSelect
                            :disabled="readonlyFormItem"
                            class="city-form-group city-bg"
                            id="input-group"
                            name="group"
                            label="name"
                            :filterable="false"
                            :options="groups"
                            v-model.trim="form.group_id"
                            :reduce="option => option.id"
                            @input="form.id=null"
                            :appendToBody="false">
                            <template #option="{option, label}">
                                <div class="d-flex flex-row">
                                    <img v-if="option.image" class="basemap-gallery-img img-icon w-24 mr-2" :src="option.image">
                                    <span class="">
                                        {{ option[label] }}
                                    </span>
                                </div>
                            </template>
                            {{ $t(`${translatedId}.model.group`) }}
                        </MaterialSelect>
                    </div>
                </div>
            </div>
            <hr class="mt-0">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <div class="col-6 col-md-3 mb-3"
                            v-for="(item, index) in groupedItems"
                            :key="`grouped-item-${item.group_id}-${index}`">
                            <label class="card-group-toggle"
                                @dblclick.prevent="onSelectedItem(item.id, item.group_id, item, $event)"
                                :title="$t(`${translatedId}.select_item`)"
                                data-toggle="tooltip-city">
                                <input type="radio"
                                    name="rouped-item-id"
                                    :id="`rouped-item-${item.id}`"
                                    :value="item.id"
                                    v-model="form.id">
                                <div class="card square square-2"
                                    :class="[{'active': form.id == item.id }]">
                                    <div class="card-body p-2 d-flex flex-column">
                                        <img class="img-item" :src="item.image ?? noImage">
                                        <h6 class="card-title">{{item.name}}</h6>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ElementMixin from "../mixins/ElementMixin";
    import NoImageIcon from '@images/no-image.jpg';

    export default {
        mixins: [
            ElementMixin,
        ],
        components:{

        },
        inject: {
            parentValidator: 'parentValidator',
        },
        props: {
            panelID: {
                type: String,
                default: 'default_layers',
            },
            value: {
                type: Object,
                default: () => {
                    return {
                        id: null,
                        group_id: null,
                        item: null,
                    }
                },
            },
            readonlyFormItem: {
                type: Boolean,
                default: true,
            },
            keyChilds: {
                type: String,
                default: 'childs',
            },
            keyGroup: {
                type: String,
                default: 'group_id',
            },
            basemapUrl: {
                type: String,
                default: null,
            },
            basemapItems: {
                type: Array,
                default: () => {
                    return []
                },
            },
        },
        data() {
            return {
                pageID: this.panelID,
                form: this.value,
                items: this.basemapItems,
            }
        },
        created() {
            this.$validator = this.parentValidator;
        },
        computed: {
            noImage() {
                return NoImageIcon;
            },
            translatedId() {
                return `${this.pageID}.basemap.gallery`;
            },
            groups() {
                return this.items.reduce((groups, item) => {
                    let {[this.keyChilds]: childs, ...rest} = item;
                    if(childs && childs.length) {
                        groups.push({...rest});
                    }
                    return groups;
                }, []);
            },
            group() {
                return this.groups.find(item => item.id == this.form.group_id);
            },
            groupedItems() {
                return this.items.filter(item => this.group ? this.group.id == item.id : true)
                .reduce((items, item) => {
                    let {[this.keyChilds]: childs, ...rest} = item;
                    items = items.concat(childs.map(item => {
                        item['group_id'] = this.keyGroup in item ? item[this.keyGroup] : 1;
                        return item;
                    }));
                    return items;
                }, []);
            },
            item() {
                return this.items.flatMap(item => item[this.keyChilds]).find(item => item.id == this.form.id);
            }
        },
        methods: {
            onSelectedItem: function(id, group_id, item, evt) {
                this.$emit('selected', {id, group_id, item: JSON.parse(JSON.stringify(item))});
            }
        },
        watch: {
            "form.id": {
                immediate: false,
                handler: function(newValue, oldValue) {
                    this.form.item = JSON.parse(JSON.stringify(this.item));
                }
            }
        },
    }
</script>

<style lang="scss">
.basemap-gallery {
    .img-icon {
        border-radius: 0.25rem;
        max-width: 100%;
        height: auto;

        &.w-16 {
            width: 1rem;
        }
        &.w-24 {
            width: 24px;
        }
    }
    .card {
        .card-body {
            img {
                filter: none !important;
                &.img-item {
                    max-width: 100%;
                    object-fit: cover;
                }
            }

            .card-title {
                margin-bottom: 0;
            }
        }
    }
}

</style>